import { render } from "./PokerBlock.vue?vue&type=template&id=c56a6524&scoped=true"
const script = {}

import "./PokerBlock.vue?vue&type=style&index=0&id=c56a6524&scoped=true&lang=scss"

import exportComponent from "D:\\Spadej Work\\SPJWEB\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56a6524"]])

export default __exports__